import { getFaro } from '../state'
import { generateUUID } from './uuid'
import { ACQUISITION_UTM_KEYS } from '../stores/acquisition-store'

/**
 * Start a fresh Faro session (new id), carrying existing session attributes
 * forward but replacing the utm/gclid subset with `newAcquisition`. Used when
 * `acquisition.resetOnNewUtm` rolls the session over on a new campaign — a new
 * id makes downstream analytics count it as a new session (GA4-style).
 */
export function startNewFaroSession(newAcquisition: Record<string, string>): void {
  const faro = getFaro()
  if (!faro) return
  const current = (faro.api.getSession()?.attributes as Record<string, string>) ?? {}
  // Carry existing attributes forward MINUS the stale utm/gclid, then apply the
  // new campaign (utm/referrer) — so the new session reflects only it.
  const attrs: Record<string, string> = Object.fromEntries(
    Object.entries(current).filter(([key]) => !ACQUISITION_UTM_KEYS.includes(key)),
  )
  Object.assign(attrs, newAcquisition)
  faro.api.setSession({ id: generateUUID(), attributes: attrs })
}
